import {Component, OnInit} from '@angular/core';
import {ModalDismissReasons, NgbModal, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {OrderModule, OrderPipe} from 'ngx-order-pipe';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterLink} from '@angular/router';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-supplier-price-list',
  templateUrl: './supplier-price-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    OrderModule,
    NgbPaginationModule,
    RouterLink,
    PaginationComponent
  ],
  styleUrls: ['./supplier-price-list.component.scss']
})
export class SupplierPriceListComponent implements OnInit {

  public user_rights: any;
  public user_data: any = {};

  public now = new Date();

  public purchase_data: any = [];
  public count = 1;

  public checked = true;
  public purchase: any =
    {
      search_purchase: ''
    }
  order = 'TRADE_NAME';
  reverse = false;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  status: any;
  index: any;
  closeResult = '';
  total = 0;

  supplier: any;
  sortedCollection: any[] = [];
  public rate_sheet: any =
    {
      vendor_id: [""],
      medicine_id: [""],
      from_date: [""],
      to_date: [""],
      price: [""],
      vat: [""],
      supplier_price_id: [""],
    }
  public po_order: any =
    {
      vendor_id: [""],
      medicine_id: [""],
      from_date: [""],
      to_date: [""],
      price: [""],
      vat: [""],
      supplier_price_id: [""],
      total: [""],
      supplier_id: [""]
    }
  rate_list: any = [];


  constructor(private orderPipe: OrderPipe, private loaderService: LoaderService, private modalService: NgbModal, public consultingService: ConsultingService, private toastr: ToastrService,) {
  }


  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getPurchaseList();
    this.listaddSupplierPrice();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public totalPrice() {
    let price = 0;
    for (const data of this.rate_list) {
      for (const item of data.ITEMS) {
        price = price + parseFloat(item.PRICE)
        item["TOTAL"] = price;
      }
    }
  }

  public clearRatesheet() {
    this.rate_sheet =
      {
        vendor_id: [""],
        medicine_id: [""],
        from_date: [""],
        to_date: [""],
        price: [""],
        vat: [""],
        supplier_price_id: [""],
      }
  }

  public clearpo() {
    this.po_order =
      {
        vendor_id: [""],
        medicine_id: [""],
        from_date: [""],
        to_date: [""],
        price: [""],
        vat: [""],
        supplier_price_id: [""],
        total: [""],
        supplier_id: [""]
      }
  }

  public getPurchaseList(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      purchase_id: '0',
      checked: this.checked
    };
    this.purchase_data = [];
    this.collection = 0;
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.consultingService.listSupplierPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        let i = 0;
        for (const data of this.purchase_data) {
          data["ID"] = this.start + i + 1
          this.purchase_data[i] = data;
          i = i + 1;
        }
        this.sortedCollection = this.orderPipe.transform(this.purchase_data, 'TRADE_NAME');
        this.collection = result['total_count'];
        this.addCheck();
      } 
    this.loaderService.display(false);
    });
  }

  getsearchlist(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.purchase.search_purchase,
      purchase_id: '0',
      checked: this.checked
    };
    this.collection = 0;
    this.purchase_data = [];
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.consultingService.listSupplierPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        let j = 0;
        for (const data of this.purchase_data) {
          data["ID"] = this.start + j + 1
          this.purchase_data[j] = data;
          j = j + 1;
        }
        this.sortedCollection = this.orderPipe.transform(this.purchase_data, 'TRADE_NAME');
        this.addCheck();
        this.collection = result['total_count'];
        const i = this.purchase_data.length;
        this.index = i + 5;
        this.status = result['status'];
      }
      this.loaderService.display(false);
    });
  }

  getCurrentlist() {
    this.checked = !this.checked;
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.purchase.search_purchase,
      purchase_id: '0',
      checked: this.checked
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.consultingService.listSupplierPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        let j = 0;
        for (const data of this.purchase_data) {
          data["ID"] = this.start + j + 1
          this.purchase_data[j] = data;
          j = j + 1;
        }
        this.sortedCollection = this.orderPipe.transform(this.purchase_data, 'TRADE_NAME');
        this.addCheck();
        this.collection = result['total_count'];
        const i = this.purchase_data.length;
        this.index = i + 5;
      } else {
        this.collection = 0;
      }
      this.loaderService.display(false);
    });
  }

  setOrder(value: string) {
    if (this.order == value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  addCheck() {
    let i = 0;
    for (const data of this.purchase_data) {
      data["CHECKED"] = false;
      this.purchase_data[i] = data;
      i = i + 1;
    }
  }

  updateChecked(i: any, supplier_id: any) {

    for (const data of this.purchase_data) {
      if (data.SUPPLIER_PRICE_ID == supplier_id) {
        data.CHECKED = data.CHECKED == false;
      }
    }
  }

  itemChecked(i: any) {
    this.rate_list[i].CHECK = this.rate_list[i].CHECK != true;
  }

  public createPO() {
    let i = 0;
    let j = 0;
    this.clearpo();
    for (const data of this.rate_list) {
      if (data.CHECK == true) {
        for (const item of data.ITEMS) {
          this.po_order.vendor_id[j] = data.VENDOR_ID
          this.po_order.supplier_id[i] = item.VENDOR_ID
          this.po_order.medicine_id[i] = item.MEDICINE_ID
          this.po_order.price[i] = item.PRICE
          i = i + 1
        }
      }
      j = j + 1
    }
    this.consultingService.createPurchaseOrder(this.po_order).subscribe((result: any) => {
      window.scrollTo(0, 0)
      this.loaderService.display(true);
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result["msg"]);
        this.listaddSupplierPrice();
      } else {
        this.toastr.error(result["msg"]);
        this.loaderService.display(false);
      }
    })

  }

  public addList(): any {

    this.clearRatesheet();
    let i = 0;
    for (const data of this.purchase_data) {
      if (data.CHECKED == true) {

        this.rate_sheet.vendor_id[i] = data.VENDOR_ID
        this.rate_sheet.medicine_id[i] = data.MEDICINE_ID
        this.rate_sheet.from_date[i] = data.FROM_DATE
        this.rate_sheet.to_date[i] = data.TO_DATE
        this.rate_sheet.price[i] = data.PRICE
        this.rate_sheet.vat[i] = data.VAT_AMOUNT
        this.rate_sheet.supplier_price_id[i] = data.SUPPLIER_PRICE_ID
        i = i + 1;
      }
    }
    if (this.rate_sheet.supplier_price_id.length > 0) {
      this.consultingService.addSupplierlist(this.rate_sheet).subscribe((result: any) => {
        window.scrollTo(0, 0)
        this.loaderService.display(true);
        if (result["status"] == "Success") {
          this.loaderService.display(false);
          this.toastr.success(result["msg"]);
          this.listaddSupplierPrice();
        } else {
          this.toastr.error(result["msg"]);
          this.loaderService.display(false);
        }
      })
    } else {
      this.toastr.error("Please select atleast one item !");
      return false;

    }
  }

  listaddSupplierPrice() {
    this.consultingService.listaddSupplierPrice().subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.rate_list = result['data'];
        let i: number;
        for (i = 0; i < this.rate_list.length; i++) {
          this.rate_list[i]["CHECK"] = false;
          i = i + 1;
        }
        this.totalPrice();
        this.loaderService.display(false);
        this.po_order = [];
        this.rate_sheet = [];
      } else {
        this.loaderService.display(false);
        this.rate_list = [];
      }
    });
  }

  popupData() {
    this.toastr.error("Can not open, Since no selected data is found!");
    return false;
  }

  ClearAddRateSheet() {
    this.consultingService.ClearAddRateSheet().subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result["msg"]);
        this.loaderService.display(false);
        this.getPurchaseList();
        this.listaddSupplierPrice();
        this.rate_list = [];
        this.po_order = [];
        this.rate_sheet = [];
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public clear_search() {
    if (this.purchase.search_purchase != '') {
      this.purchase.search_purchase = '';
      this.getPurchaseList();
    }
  }

  public deleteSupplierPrice(item: any) {
    const postData = {
      supplier_price_id: item.SUPPLIER_PRICE_ID
    };

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.deleteSupplierPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result["msg"]);
        this.getsearchlist();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  deleteaddSupplierPrice(item: any) {

    const postData = {

      supplier_price_temp_id: item.SUPPLIER_PRICE_TEMP_ID
    };

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.deleteaddSupplierPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result["msg"]);
        this.listaddSupplierPrice();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  delete(item: any) {
    if (confirm("Are you sure to delete ?")) {
      this.deleteSupplierPrice(item);
    }
  }

  delete_rate(item: any) {
    if (confirm("Are you sure to delete ?")) {
      this.deleteaddSupplierPrice(item);
    }
  }

  clear_all() {
    if (confirm("Are you sure to clear all datas ?")) {
      this.ClearAddRateSheet();
    }
  }

  protected open(content: any) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
